module.exports = __webpack_public_path__ + "site-85.jpg?1a4d9c2335a3a5a2f30f9269069968f9";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/portfolio/site-85.jpg
 ** module id = 197
 ** module chunks = 0
 **/